import React from 'react';
import { motion } from 'framer-motion';
import { scrollToOffer } from '../utils/scrollToOffer';
export function HeroSection() {
  return <section className="relative pt-3 pb-12 md:pt-4 md:pb-16 overflow-hidden bg-[#064e3b]" data-id="element-87">
      <div aria-hidden="true" className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-88">
        <div className="absolute -top-[20%] left-1/2 -translate-x-1/2 w-[100%] h-[80%] rounded-full bg-emerald-500/20 blur-[120px]" data-id="element-89" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl text-center" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-6 py-2.5 mb-8 rounded-full border border-emerald-400/30 bg-emerald-900/40 text-emerald-200 font-semibold tracking-[0.15em] uppercase md:text-xs text-[9px]" data-id="element-91">
          ✨ SISTEMA CLÍNICO LISTO PARA USAR EN TU CONSULTORIO
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-heading md:text-5xl lg:text-6xl font-extrabold text-white mb-6 text-[18px]" data-id="element-92">
          Dejá de explicar lo mismo mil veces.{' '}
          <span className="text-yellow-400" data-id="element-93">
            Material didáctico listo para tus pacientes.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-6 relative" data-id="element-94">
          <img src="https://cdn.magicpatterns.com/uploads/jZffEDPzmHH2USTTout28h/Texto_del_parrafo_(10)_(1).webp" alt="Masterpack Protocolos Clínicos de Nutrición" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" className="w-full h-auto max-w-3xl mx-auto rounded-2xl shadow-2xl shadow-black/50 border border-emerald-800" data-id="element-95" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-emerald-100 mb-8 max-w-2xl mx-auto text-[14px]" data-id="element-96">
          El sistema completo de protocolos nutricionales para ahorrar tiempo,
          mejorar la atención y entregar materiales profesionales desde el
          primer día.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-97">
          <motion.a href="#comprar" onClick={scrollToOffer} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full sm:w-auto bg-yellow-400 hover:bg-yellow-300 text-emerald-900 font-extrabold px-8 py-4 rounded-full shadow-lg shadow-yellow-500/20 transition-colors mb-4 text-[18px] md:text-[20px]" data-id="element-98">
            🚀 SÍ, QUIERO EL MASTERPACK HOY
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-emerald-200" data-id="element-99">
            <span data-id="element-100">
              <span aria-hidden="true" data-id="element-101">⭐⭐⭐⭐⭐</span> 4.9/5 — Avalado por
              profesionales de la salud
            </span>
            <span aria-hidden="true" className="hidden sm:inline text-emerald-400" data-id="element-102">
              |
            </span>
            <span data-id="element-103">
              <span aria-hidden="true" data-id="element-104">🛡️</span> Acceso Inmediato y Licencia de
              Uso de por Vida
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}